
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schools/blog",
      function () {
        return require("private-next-pages/schools/blog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schools/blog"])
      });
    }
  